const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  token: state => state.user.token,
  skuList: state => state.user.skuList,
  multipleList: state => state.user.multipleList,
  skuGiftList: state => state.user.skuGiftList,
  taglistNew: state => state.user.taglistNew,
  whichLevel: state => state.user.whichLevel,
  skuActiveList: state => state.user.skuActiveList,
  skuGiftActiveList: state => state.user.skuGiftActiveList,
  skuRankActiveList: state => state.user.skuRankActiveList,
  tableTabs: state => state.user.tableTabs,
  couponObj: state => state.user.couponObj,
  activeSkuOrSkuGift: state => state.user.activeSkuOrSkuGift,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  shopId: state => state.user.shopId,
  isAddShop: state => state.user.isAddShop,
  isFromAddActive: state => state.user.isFromAddActive,
  isDestroyDetailPic: state => state.user.isDestroyDetailPic,
  brandList: state => state.user.brandList,
  merchantId: state => state.user.merchantId,
  roles: state => state.user.roles,
  couponNumAll: state => state.user.couponNumAll,
  shipTabType: state => state.user.shipTabType,
  addRouters: state => state.permission.addRouters,
  routers: state => state.permission.routers
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js